// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__2A7qU","content":"AppLayout_content__SNmJM","contentCollapsed":"AppLayout_contentCollapsed__qu7P6"};